import { gql } from '__generated__';

export const ScannerAttributesFragment = gql(`
  fragment ScannerAttributes on Scanner {
    id
    event {
      id
    }
    title
    edit_start_numbers
    code_count(cached: false)
    check_in_count
    enabled
    segment {
      id
      registration_filters {
        ...RegistrationFilters
      }
    }
  }
`);

export default gql(`
  query GetScanner($project_id: ID!, $scanner_id: ID!) {
    project(id: $project_id) {
      id
      scanner(id: $scanner_id) {
        ...ScannerAttributes
      }
    }
  }
`);
